module.exports = __webpack_public_path__ + "static/img/logo-qr.ca83f07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-qr.png
// module id = 715
// module chunks = 140